import React from "react";

import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(theme => ({
	contactsHeader: {
		display: "flex",
		alignItems: "center",
		flexWrap: "wrap",
		columnGap: theme.spacing(1.5),
		rowGap: theme.spacing(0.75),
		minWidth: 0,
		padding: "0px 6px 8px 6px",
		"& > *": {
			minWidth: 0,
		},
		"& .MuiChip-root": {
			flex: "0 0 auto",
		},
	},
}));

const MainHeader = ({ children }) => {
	const classes = useStyles();

	return <div className={classes.contactsHeader}>{children}</div>;
};

export default MainHeader;
